export const loads = {
  data() {
    return {
      busy: true,
      list: []
    }
  },
}

export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emptyValue(v) {
      return v === null || v === undefined || v === ""
    },
    debounce(fn, wait) {
      let timer;
      return function (...args) {
        if (timer) {
          clearTimeout(timer);
        }
        const context = this;
        timer = setTimeout(() => {
          fn.apply(context, args);
        }, wait);
      }
    },
    extractCSS(component, isChild = false) {

      const spacing_options = { "none": 0, "small": 0.5, "medium": 1, "large": 1.5, "xl": 2 }
      const props = {};

      const prefix = isChild ? "child_" : "";

      const isEmpty = (value) => (value == undefined || value == null || (typeof value === "string" && value.trim().length === 0))

      component?.css?.forEach(ops => {
        // Shorten and post-fix size names for CSS custom properties.
        const size = ops.size.replace("mobile", "").replace("tablet", "_md").replace("desktop", "_lg");

        props[`--letter_spacing${size}`] = ops.spread_letters ? "1.8px" : null;
        props[`--text_transform${size}`] = ops.text_transform ? ops.text_transform : null;
        props[`--border_radius${size}`] = !!ops.border_radius ? `${ops.border_radius}px` : null;
        props[`--grid_gap${size}`] = !!ops.gap ? `${ops.gap}rem` : null;
        props[`--flex_gap${size}`] = !!ops.flex_gap ? `${ops.flex_gap}rem` : null;
        props[`--flex_dir${size}`] = ops.flex_direction ?? null;
        props[`--flex_align_items${size}`] = ops.flex_align_items ?? null;
        props[`--flex_justify_content${size}`] = ops.flex_justify_content ?? null;
        props[`--text_align${size}`] = ops.text_align ?? null;
        props[`--align_self${size}`] = ops.align_self ?? null;
        props[`--${prefix}item_order${size}`] = ops.item_order ?? null;
        props[`--background_color${size}`] = ops.background_color || null;

        if (!isEmpty(spacing_options[ops.spacing_top])) {
          props[`--${prefix}spacer_top${size}`] = spacing_options[ops.spacing_top] + "rem";
        }
        if (!isEmpty(spacing_options[ops.spacing_bottom])) {
          props[`--${prefix}spacer_bottom${size}`] = spacing_options[ops.spacing_bottom] + "rem" ?? 0;
        }
        if (!isEmpty(spacing_options[ops.spacing_x])) {
          props[`--${prefix}spacer_x${size}`] = spacing_options[ops.spacing_x] + "rem" ?? 0;
        }
      })
      // Remove null values
      Object.keys(props).forEach((k) => (props[k] == null || props[k] == '') && delete props[k]);
      return props;
    },

    transformImage(image, option, replaceHTTPS) {
      var imageService = '//img2.storyblok.com/'
      let replace = replaceHTTPS ? "https://a.storyblok.com" : "//a.storyblok.com";
      var path = image?.replace(replace, '')
      return imageService + option + path
    },
  },
};
